module.exports = __webpack_public_path__ + "static/media/Internationalpic2.63c24c62.png";